export const RichResponseEmits = {
    BLOCKPROMPT: 'blockprompt',
    UNBLOCKPROMPT: 'unblockprompt',
    SENDMESSAGE: 'sendmessage',
};
